import { useTranslation } from 'react-i18next';

import { Tabs } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import useFeature from '../packages/kakapo-ui-application/hooks/useFeature';

export default function UserFeedbackTabs(props: { user?: graphql.User }) {
	const { t } = useTranslation();

	const hasFeedback = useFeature('2021.feedback');
	const hasCompliments = useFeature('2021.compliments');

	return (
		<Tabs.Container>
			{props.user && (
				<>
					{hasFeedback && props.user?.viewerCanViewFeedback && (
						<Tabs.Item
							title={t('user.feedback.tab.incoming.title', { name: props.user.firstName })}
							selected
							path={`/users/${props.user.id}/feedback`}
						/>
					)}
					{hasCompliments && (
						<Tabs.Item
							title={t('user.feedback.tab.compliments.title', { name: props.user.firstName })}
							path={`/users/${props.user.id}/feedback/compliments`}
						/>
					)}
				</>
			)}
		</Tabs.Container>
	);
}
